export const BREAKPOINTS_LEGACY = {
  xs: '600px',
  sm: '960px',
  md: '1280px',
  lg: '1920px',
};

export const BREAKPOINTS_TAILWIND = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};
